import { all } from 'redux-saga/effects'

//Advertisers
import { Sagas as AdvertiserCreate } from 'modules/Advertisers/Create'
import { Sagas as AdvertisersList } from 'modules/Advertisers/List'

//Agency
import { Sagas as Clients } from 'modules/Agency/Clients'
import { Sagas as AgencyCardSaga } from 'modules/Agency/AgencyCard'
import { Sagas as Requests } from 'modules/Agency/Requests'
import { Sagas as AppSaga } from 'modules/App/saga'
import { Sagas as AuthSaga } from 'modules/Auth'

//AutoReplenish
import { Sagas as AutoReplenish } from 'modules/AutoReplenish'

//Finance
import { Sagas as PaymentProfiles } from 'modules/Finance/PaymentProfiles'
import { Sagas as Wallets } from 'modules/Finance/Wallets'

// Forms
import { FormsSagas } from 'modules/Forms'

// Billing
import { Sagas as BillingSaga } from 'modules/Forms/Billing'
import { Sagas as PaymentOrder } from 'modules/Billing/PaymentOrder'

//Notifications
import { Sagas as NotificationsSaga } from 'modules/Notifications'

//Oauth
import { Sagas as OauthSaga } from 'modules/Oauth'

//Promised Payment
import { Sagas as PromisedPayment } from 'modules/Finance/PromisedPayment'

//Recommendations
import { Sagas as RecommendationsAudits } from 'modules/Recommendations/Audits'
import { Sagas as Benchmarks } from 'modules/Recommendations/Benchmarks'
import { Sagas as RecommendationsListSaga } from 'modules/Recommendations/CampaignsRecommendations/TypesList'
import { Sagas as RecommendationsTypeSaga } from 'modules/Recommendations/CampaignsRecommendations/Type'

//Referral
import { Sagas as Referrals } from 'modules/Referral'
import { Sagas as ReferralLinks } from 'modules/Referral/ReferralLinks'
import { Sagas as ReferralClients } from 'modules/Referral/ReferralClients'

//Services
import { Sagas as ServicesAccess } from 'modules/Services/Access/List'
import { Sagas as ServicesAccount } from 'modules/Services/Account'
import { Sagas as AccountAdvertiserInfoEdit } from 'modules/Services/AccountAdvertiserInfoEdit'
import { Sagas as AccountRegisterSaga } from 'modules/Services/AccountCreate'
import { Sagas as ServicesCampaigns } from 'modules/Services/Campaigns/Main'
import { Sagas as ServicesCampaign } from 'modules/Services/Campaigns/Start'
import { Sagas as ServicesNetwork } from 'modules/Services/Network'
import { Sagas as ServicesNetworksList } from 'modules/Services/NetworksList'
import { Sagas as ServicesRefund } from 'modules/Services/Refund'

//Campaigns editor
import { Sagas as CampaignsEditor } from 'modules/Services/CampaignsEditor'

//Statistics
import { Sagas as StatisticsAccount } from 'modules/Statistics/Account'
// import { Sagas as StatisticsAccountConnect } from 'modules/Statistics/subcomponents/AccountConnect'
import { Sagas as StatisticsCampaign } from 'modules/Statistics/Campaign'
import { Sagas as Statistics } from 'modules/Statistics/Main'
import { Sagas as PulseSaga } from 'modules/Statistics/Pulse'

//Tickets
import { Sagas as TicketsList } from 'modules/Tickets/List'
import { Sagas as Ticket } from 'modules/Tickets/Ticket'

//User
import { Sagas as DoubleFA } from 'modules/User/Security/2fa'
import { Sagas as UserPassword } from 'modules/User/Security/Password'
import { Sagas as UserAccountsConnected } from 'modules/User/Accounts'
import { Sagas as UserProfile } from 'modules/User/Profile'

//Partner Program
import { Sagas as PartnersProgram } from 'modules/PartnersProgram'
import { Sagas as BudgetEditor } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor'

// Media Planner
import { Sagas as MediaPlanner } from 'modules/MediaPlanner'

//Countries
import { Sagas as Countries } from 'modules/Countries'

//Stories
import { Sagas as Stories } from 'modules/Stories'

//Accounts marketplace
import { Sagas as AccountsMarketplaceList } from 'modules/AccountsMarketplace/Categories'
import { Sagas as AccountsMarketplaceCategory } from 'modules/AccountsMarketplace/Category'
import { Sagas as AccountsMarketplaceProducts } from 'modules/AccountsMarketplace/Products'
import { Sagas as AccountsMarketplaceProduct } from 'modules/AccountsMarketplace/Product'

export default function* rootSaga() {
  yield all([
    AuthSaga(),
    AppSaga(),
    AutoReplenish(),
    NotificationsSaga(),
    AgencyCardSaga(),
    Clients(),
    Requests(),
    Referrals(),
    ReferralLinks(),
    ReferralClients(),
    Statistics(),
    StatisticsAccount(),
    StatisticsCampaign(),
    // StatisticsAccountConnect(),
    PulseSaga(),
    UserPassword(),
    UserAccountsConnected(),
    UserProfile(),
    DoubleFA(),
    PaymentProfiles(),
    AdvertisersList(),
    AdvertiserCreate(),
    ServicesAccount(),
    ServicesNetwork(),
    ServicesAccess(),
    ServicesRefund(),
    ServicesNetworksList(),
    ServicesCampaigns(),
    ServicesCampaign(),
    CampaignsEditor(),
    BudgetEditor(),
    AccountRegisterSaga(),
    AccountAdvertiserInfoEdit(),
    BillingSaga(),
    Wallets(),
    PromisedPayment(),
    RecommendationsAudits(),
    Benchmarks(),
    RecommendationsListSaga(),
    RecommendationsTypeSaga(),
    OauthSaga(),
    TicketsList(),
    Ticket(),
    PaymentOrder(),
    PartnersProgram(),
    Countries(),
    Stories(),
    MediaPlanner(),
    AccountsMarketplaceList(),
    AccountsMarketplaceCategory(),
    AccountsMarketplaceProducts(),
    AccountsMarketplaceProduct(),
    ...FormsSagas.map((saga) => saga()),
  ])
}
